import { z } from "zod";

export const schema = z.object({
  email: z.string().email("Invalid email address"),
});
